const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';

function onIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    } else {
      entry.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );
  
  if (animationTriggerElements.length === 0) {
    return;
  }

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    });
    return;
  }

  animationTriggerElements.forEach((element) => {
    element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
  });

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px',
    threshold: 0.1
  });

  animationTriggerElements.forEach((element) => {
    observer.observe(element);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      initializeScrollAnimationTrigger();
    }, 100);
  });
} else {
  setTimeout(() => {
    initializeScrollAnimationTrigger();
  }, 100);
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    initializeScrollAnimationTrigger(event.target, true);
  });
}

window.reinitScrollAnimations = initializeScrollAnimationTrigger;